namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_user_dashboards, {
		width: '100%',
		minWidth: 0,
		height: '100%',
		minHeight: 0,
		maxHeight: '100%',
		overflow: 'hidden',

		flex: {
			grow: 1,
			shrink: 1,
		},

		Body: {
			minHeight: 0,
		},

		Body_content: {
			minHeight: 0,
			gap: $mol_gap.block,
		},

		Head: {
			alignItems: 'center',
		},

		Title: {
			alignItems: 'center',
			flexWrap: 'wrap',
		},

		Tools: {
			alignItems: 'center',
		},

		User_select: {
			width: '100%',
		},

		Toolbar: {
			alignItems: 'center',
			gap: $mol_gap.block,
		},

		Dashboard_search: {
			width: '300px',
			maxWidth: '100%',
			flex: { grow: 0, shrink: 1 },
		},

		Section_switch: {
			flexWrap: 'wrap',
			Option: {
				'[mol_check_checked]': {
					true: {
						color: $mol_theme.current,
					},
				},
			},
		},

		Section_content: {
			flexDirection: 'column',
			minWidth: 0,
			minHeight: 0,
			gap: $mol_gap.block,
		},

		Monitoring_content: {
			flexDirection: 'column',
			gap: $mol_gap.block,
		},

		Mention_stats_content: {
			flexDirection: 'column',
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Wordstat_content: {
			flexDirection: 'column',
			gap: $mol_gap.block,
			minWidth: 0,
		},

		Agent_content: {
			flexDirection: 'column',
			gap: $mol_gap.block,
		},

		Logs_content: {
			flexDirection: 'column',
			gap: $mol_gap.block,
		},

		Wordstat_toolbar: {
			alignItems: 'center',
		},

		Mention_stats_toolbar: {
			alignItems: 'center',
		},

		Mention_stats_list: {
			flexDirection: 'column',
			gap: 0,
			width: '100%',
		},

		Mention_stats_task: {
			alignItems: 'center',
			gap: '8px',
			minWidth: 0,
			width: '100%',
			minHeight: '40px',
			flex: { grow: 0, shrink: 0 },
		},

		Mention_stats_task_title: {
			minWidth: 0,
			flex: { grow: 1, shrink: 1 },
		},

		Mention_stats_task_delete: {
			color: '#ff6666',
		},

		Mention_stats_task_delete_confirm: {
			flexDirection: 'row',
			alignItems: 'center',
			gap: 0,
		},

		Mention_stats_dashboard: {
			minWidth: 0,
			height: '70vh',
		},

		Wordstat_list: {
			flexDirection: 'column',
			gap: 0,
			width: '100%',
			overflow: 'auto',
		},

		Wordstat_rows: {
			flexDirection: 'column',
			gap: 0,
			minWidth: '900px',
		},

		Wordstat_table_head: {
			display: 'grid',
			gridTemplateColumns: 'minmax(180px, 1.2fr) minmax(220px, 1.5fr) 140px 160px 150px 112px',
			gap: '8px',
			minWidth: '900px',
			padding: { left: '8px', right: '8px' },
			color: $mol_theme.shade,
			font: { size: '12px', weight: 'bold' },
		},

		Wordstat_task: {
			display: 'grid',
			gridTemplateColumns: 'minmax(180px, 1.2fr) minmax(220px, 1.5fr) 140px 160px 150px 112px',
			alignItems: 'center',
			gap: '8px',
			minWidth: 0,
			width: '100%',
			minHeight: '40px',
			padding: { left: '8px', right: '8px' },
			flex: { grow: 0, shrink: 0 },
		},

		Wordstat_task_title: {
			minWidth: 0,
			width: '100%',
			overflowWrap: 'anywhere',
		},

		Wordstat_task_queries: {
			minWidth: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		},

		Wordstat_task_subtasks: {
			minWidth: 0,
		},

		Wordstat_task_period: {
			minWidth: 0,
		},

		Wordstat_task_daily: {
			justifyContent: 'center',
		},

		Wordstat_task_actions: {
			alignItems: 'center',
			justifyContent: 'flex-end',
		},

		Wordstat_task_delete: {
			color: '#ff6666',
		},

		Wordstat_task_delete_confirm: {
			flexDirection: 'row',
			alignItems: 'center',
			gap: 0,
		},

		Wordstat_dashboard: {
			minWidth: 0,
			height: '70vh',
		},

		Dashboard_create: {
			alignSelf: 'flex-start',
		},

		Dashboard: {
			gap: '8px',
			padding: {
				top: '10px',
				bottom: '10px',
			},
			border: {
				top: {
					width: '1px',
					style: 'solid',
					color: $mol_theme.line,
				},
			},
		},

		Dashboard_head: {
			display: 'flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '8px',
		},

		Dashboard_title: {
			minWidth: 0,
			width: '12rem',
			maxWidth: '100%',
			flex: {
				grow: 1,
				shrink: 1,
			},
			font: {
				weight: 'bold',
			},
			overflowWrap: 'anywhere',
		},

		Csv_to_duckdb: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Dashboard_access: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			Trigger: {
				minHeight: '32px',
				padding: {
					left: '10px',
					right: '10px',
					top: 0,
					bottom: 0,
				},
			},
		},

		Dashboard_tags: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Dashboard_tags_bubble: {
			width: '320px',
			flexDirection: 'column',
			maxHeight: '320px',
			background: { color: $mol_theme.back },
			overflow: 'auto',
			padding: 0,
		},

		Dashboard_rebuild_status: {
			padding: {
				left: 0,
				right: 0,
			},
			color: $shm_theme.active,
		},

		Dashboard_tags_rebuild: {
			margin: { top: $mol_gap.space },
		},

		Dashboard_tag: {
			width: '100%',
		},

		Upload_tags: {
			flexDirection: 'column',
			gap: $mol_gap.space,
			padding: $mol_gap.block,
			background: { color: $mol_theme.hover },
		},

		Upload_tags_title: {
			font: { weight: 'bold' },
		},

		Upload_tags_list: {
			flexDirection: 'column',
		},

		Upload_tags_actions: {
			gap: $mol_gap.space,
		},

		Dashboard_access_bubble: {
			flexDirection: 'column',
			gap: 0,
			minWidth: '240px',
			maxHeight: '320px',
			overflow: 'auto',
			padding: {
				top: '6px',
				bottom: '6px',
			},
		},

		Dashboard_user: {
			width: '100%',
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
			font: { size: '16px' },
			':hover': {
				background: {
					color: $mol_theme.hover,
				},
			},
		},

		Dashboard_delete: {
			margin: {
				left: 'auto',
			},
			flex: {
				grow: 0,
				shrink: 0,
			},
			Trigger: {
				color: '#ff6666',
				minWidth: '32px',
				minHeight: '32px',
				justifyContent: 'center',
				padding: 0,
			},
		},

		File_delete: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			Trigger: {
				color: '#ff6666',
				minWidth: '28px',
				minHeight: '28px',
				justifyContent: 'center',
				padding: 0,
			},
		},

		Auto_update: {
			flex: {
				grow: 0,
				shrink: 0,
			},
			Trigger: {
				minHeight: '28px',
				padding: {
					left: '8px',
					right: '8px',
					top: 0,
					bottom: 0,
				},
			},
		},

		Auto_update_form: {
			flexDirection: 'column',
			gap: $mol_gap.space,
			minWidth: '240px',
			padding: {
				top: 0,
				right: 0,
				bottom: $mol_gap.block,
				left: 0,
			},
		},

		Auto_update_dashboard: {
			font: {
				weight: 'bold',
			},
			padding: {
				left: $mol_gap.space,
				right: $mol_gap.space,
			},
		},

		Auto_update_actions: {
			gap: $mol_gap.space,
			justifyContent: 'flex-end',
			padding: {
				left: $mol_gap.space,
			},
		},

		Dashboard_delete_bubble: {
			flexDirection: 'column',
			gap: 0,
			padding: 0,
		},

		File_delete_bubble: {
			flexDirection: 'column',
			gap: 0,
			padding: 0,
		},

		Dashboard_delete_text: {
			alignItems: 'center',
			minHeight: '32px',
			padding: {
				left: '12px',
				right: '12px',
			},
		},

		File_delete_text: {
			alignItems: 'center',
			minHeight: '32px',
			padding: {
				left: '12px',
				right: '12px',
			},
		},

		Dashboard_delete_yes: {
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
		},

		File_delete_yes: {
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
		},

		Dashboard_delete_no: {
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
		},

		File_delete_no: {
			minHeight: '32px',
			justifyContent: 'flex-start',
			padding: {
				left: '12px',
				right: '12px',
				top: 0,
				bottom: 0,
			},
		},

		Files: {
			gap: '4px',
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
			},
		},

		File: {
			flexWrap: 'wrap',
			gap: '8px',
			minWidth: 0,
			alignItems: 'center',
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
			':hover': {
				background: {
					color: $mol_theme.hover,
				},
			},
		},

		File_title: {
			flex: { grow: 1, shrink: 1, basis: '24rem' },
			gap: '8px',
			minWidth: 0,
			alignItems: 'center',
			flexWrap: 'nowrap',
		},

		File_actions: {
			minWidth: 0,
			flexWrap: 'wrap',
			alignItems: 'center',
			gap: '8px',
		},

		File_title_text: {
			minWidth: 0,
			width: 'auto',
			flex: {
				grow: 0,
				shrink: 1,
			},
			overflowWrap: 'anywhere',
		},

		File_info: {
			flexDirection: 'column',
			minWidth: 0,
			flex: { grow: 1, shrink: 1, basis: 0 },
		},

		File_name: {
			minWidth: 0,
			display: 'block',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis',
			color: $mol_theme.shade,
			opacity: .65,
			font: {
				size: '12px',
			},
		},

		File_last_day: {
			minWidth: 0,
			color: $mol_theme.text,
			font: {
				size: '12px',
			},
		},

		File_append: {
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		More: {
			alignSelf: 'flex-start',
		},

		Log_list: {
			gap: '4px',
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
			},
		},

		Log_head: {
			display: 'grid',
			gridTemplateColumns: '160px 96px minmax(180px, 1fr) minmax(220px, 1fr)',
			gap: '8px',
			minWidth: 0,
			color: $mol_theme.shade,
			font: {
				size: '12px',
				weight: 'bold',
			},
		},

		Log_row: {
			display: 'grid',
			gridTemplateColumns: '160px 96px minmax(180px, 1fr) minmax(220px, 1fr)',
			gap: '8px',
			minWidth: 0,
			alignItems: 'center',
			color: $mol_theme.shade,
			font: {
				size: '13px',
			},
			':hover': {
				background: {
					color: $mol_theme.hover,
				},
			},
		},

		Log_head_created: {
			minWidth: 0,
		},

		Log_head_event: {
			minWidth: 0,
		},

		Log_head_url: {
			minWidth: 0,
		},

		Log_head_user_agent: {
			minWidth: 0,
		},

		Log_created: {
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Log_event: {
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Log_url: {
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Log_user_agent: {
			minWidth: 0,
			overflowWrap: 'anywhere',
		},

		Log_more: {
			alignSelf: 'flex-start',
		},

		No_logs: {
			color: $mol_theme.shade,
		},

		No_files: {
			color: $mol_theme.shade,
		},
	} )

}
